import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import JapanToIndia from "@/pages/JapanToIndia";
import ExpressPartner from "@/pages/ExpressPartner";
import KoreanCosmeticsSourcing from "@/pages/KoreanCosmeticsSourcing";
import ExportFromIndia from "@/pages/ExportFromIndia";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import QuickFacts from "@/components/site/QuickFacts";
import Services from "@/components/site/Services";
import HowItWorks from "@/components/site/HowItWorks";
import WhyUs from "@/components/site/WhyUs";
import Guarantees from "@/components/site/Guarantees";
import Ports from "@/components/site/Ports";
import Countries from "@/components/site/Countries";
import PriorityCountries from "@/components/site/PriorityCountries";
import Commodities from "@/components/site/Commodities";
import Comparison from "@/components/site/Comparison";
import CaseStudies from "@/components/site/CaseStudies";
import Testimonials from "@/components/site/Testimonials";
import FounderNote from "@/components/site/FounderNote";
import FAQ from "@/components/site/FAQ";
import Insights from "@/components/site/Insights";
import Glossary from "@/components/site/Glossary";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingCTA from "@/components/site/FloatingCTA";
import FAQStructuredData from "@/components/site/FAQStructuredData";
import SchemaGraph from "@/components/site/SchemaGraph";
import SeoBlock from "@/components/site/SeoBlock";

const HomePage = () => {
  useEffect(() => {
    document.title =
      "Custom Clearance Partner | Air Express Customs Clearance & Last Mile Delivery in India | Delhi NCR";
  }, []);

  return (
    <div className="grain min-h-screen bg-[#F9FAFB] text-[#101828]" data-testid="home-page">
      <FAQStructuredData />
      <SchemaGraph />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <QuickFacts />
        <Services />
        <HowItWorks />
        <WhyUs />
        <Guarantees />
        <Ports />
        <Countries />
        <PriorityCountries />
        <Commodities />
        <Comparison />
        <CaseStudies />
        <Testimonials />
        <FounderNote />
        <FAQ />
        <Insights />
        <Glossary />
        <SeoBlock />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
      <Toaster position="top-right" richColors />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/japan-to-india" element={<JapanToIndia />} />
          <Route path="/express-clearance-partner-india" element={<ExpressPartner />} />
          <Route path="/korean-cosmetics-sourcing" element={<KoreanCosmeticsSourcing />} />
          <Route path="/export-from-india-ddp" element={<ExportFromIndia />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
